import { getRequestListLight } from '../../../../api'
import {
  ASYNC_SELECT_LOAD_ALL_PAGE_SIZE_PARAMS,
  ButtonAsyncSelect as ButtonAsyncSelectComponent,
  ButtonMultiSelectControl,
  getAsyncSelectShowSelectedApiParamIdPK,
  SelectDropdownListHeader,
} from '../../../Select'
import { Container } from '../../Container'
import { useSelectState } from '../Selects.hooks'
import { toRequestAsyncSelectItems } from '../Selects.utils'

import ServiceRequestIcon from '../../../../icons/service-request.svg'

function ButtonAsyncSearchMultiSelect() {
  const { handleClear, handleSelectAll, handleSelectItem, value } =
    useSelectState({
      multi: true,
    })

  return (
    <Container label='Async button multi select with search input inside dropdown'>
      <ButtonAsyncSelectComponent
        multi
        Control={ButtonMultiSelectControl}
        EntityIcon={ServiceRequestIcon}
        controlProps={{
          contentProps: {
            placeholderProps: {
              text: 'Select an option',
            },
          },
        }}
        getData={getRequestListLight}
        getShowSelectedApiParam={getAsyncSelectShowSelectedApiParamIdPK}
        listProps={{
          Header: SelectDropdownListHeader,
          headerProps: {
            SelectAll: null,
          },
        }}
        loadAllApiParams={ASYNC_SELECT_LOAD_ALL_PAGE_SIZE_PARAMS}
        style={{ width: 240 }}
        toPreparedItems={toRequestAsyncSelectItems}
        value={value}
        onClear={handleClear}
        onSelectAll={handleSelectAll}
        onSelectItem={handleSelectItem}
      />
    </Container>
  )
}

export default ButtonAsyncSearchMultiSelect
